import { UpcomingMatchesSchema } from '@/views/sports/UpcomingMatches/styles/UpcomingMatches.styles';

export const upcomingMatchesStyles: UpcomingMatchesSchema = {
  pageHeader: {
    fontSize: 'md',
    textShadow: '0px 3px 4px rgba(0, 0, 0, 0.25)',
    color: 'beta.300',
    fontFamily: 'Fraunces',
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  stackWrapper: {
    color: 'white',
    p: '0',
    pt: '2',
  },
  hStackWrapper: {
    justifyContent: 'flex-end',
  },
  sortByText: {
    fontSize: '2xs',
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  scrollButtonGroup: {
    variant: 'filter',
    bg: 'none',
    boxShadow: 'none',
    borderRadius: 'md',
    pos: 'relative',
    gap: '2',
  },
  flexRenderSortingMobile: {
    justify: 'flex-end',
  },
  loadingSkeletonText: {
    my: '4',
    noOfLines: 2,
    spacing: '4',
    skeletonHeight: '2',
  },
  mainStackWrapper: {
    spacing: '4',
  },
  mainStackInner: {
    spacing: '4',
  },
  heading: {
    color: 'beta.300',
    textShadow: '0px 3px 4px rgba(0, 0, 0, 0.25)',
    fontFamily: 'Fraunces',
    alignItems: 'center',
    display: 'flex',
    fontSize: 'md',
    gap: '1',
  },
  headingIcon: {
    color: 'alpha.600',
    sx: {},
  },
  propositionButton: {
    flex: '1',
    height: '38px',
    display: 'initial',
  },
  boxSportWrapper: {
    borderColor: 'whiteAlpha.500',
    borderWidth: '1px',
    h: '100%',
  },
  buttonSport: {
    borderColor: 'beta.400',
  },
  buttonAllSports: {
    borderColor: 'beta.400',
  },
};
